import hooks from './shipment-matches.hooks';

export default (app) => {
  const service = app.service('api/shipment-matches');

  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };

  service.hooks(hooks);
};
